import React from 'react';
import { Icon as LegacyIcon } from '@ant-design/compatible';
import { Row, Col, Input, Card, Tag, Popover, Tooltip, Button } from 'antd';
import { FormattedMessage, formatMessage } from 'umi-plugin-react/locale';
import styles from './index.less';
import { capitalizeFirstLetter } from '../../../helpers/capitalizeFirstLetter';
import AllServices from '../../../../config/AllServices';
import { getCategoryName } from '@/helpers/getCategoryName';
import { getColorBySeverity } from '@/components/RiskCard/helpers';
import { formatBadges, truncateString } from '@/utils/utils';
import _ from 'lodash';
const { Meta } = Card;

function SingleSignatureDetail(props) {
  let {
    signatureName,
    riskLevel,
    status,
    service,
    firstSeen,
    cloudAccounts,
    riskType,
    cvssVector,
    cvss3Severity,
    AffectedPackages,
    filteredResourcesOfSingleRisk,
    globalCategories,
    cvssScore,
    category,
    _cveId,
  } = props;
  const [malwareHashes, setMalwareHashes] = React.useState([]);
  const [virusTotalLink, setVirusTotalLink] = React.useState('');
  riskLevel = capitalizeFirstLetter(riskLevel);

  const MorePackages = (
    <div>{AffectedPackages?.map((item, index) => index >= 4 && <p>{item.name}</p>)}</div>
  );
  React.useEffect(() => {
    if (riskType === 'malware' && filteredResourcesOfSingleRisk[0]) {
      let sha256Index = filteredResourcesOfSingleRisk[0]?.cloudXRayRisks?.malwares[
        signatureName
      ]?.filesInfected[0]?.hashes.findIndex(item => item.type === 'sha256');
      let hashes =
        filteredResourcesOfSingleRisk[0]?.cloudXRayRisks?.malwares[signatureName]?.filesInfected[0]
          ?.hashes;
      setMalwareHashes(hashes);
      setVirusTotalLink(`https://www.virustotal.com/gui/search/${hashes[sha256Index]?.value}`);
    }
  });

  const renderFix = () => {
    return AffectedPackages?.every(
      item => item.fixState && item.fixState.toLowerCase() == 'open'
    ) ? (
      <span>Yes</span>
    ) : (
      <span>No</span>
    );
  };

  const renderCategory = () => {
    const isCatgoryName = getCategoryName(signatureName, globalCategories);

    if (isCatgoryName) {
      return formatBadges(isCatgoryName);
    } else {
      return formatBadges(category);
    }
  };
  return (
    <div>
      <Card
        style={{
          marginTop: '7px',
        }}
        bodyStyle={{ paddingBottom: '0px' }}
        bordered={false}
      >
        <div className="sig-card" style={{ marginTop: -24 }}>
          <Row type="flex" justify="space-between" style={{ marginBottom: 25 }}>
            <Col span={2}>
              <Meta
                title={<div className={styles.title}>Status</div>}
                description={
                  <div className={styles.text}>
                    <LegacyIcon
                      style={{
                        color:
                          riskType == 'malware' ||
                          riskType == 'osVulnerability' ||
                          (status && status === 'fail')
                            ? '#F4657C'
                            : '#3ADFA3',
                        fontSize: 30,
                      }}
                      type={
                        riskType == 'malware' ||
                        riskType == 'osVulnerability' ||
                        (status && status.toLowerCase() === 'fail')
                          ? 'close-circle-o'
                          : 'check-circle-o'
                      }
                    />
                  </div>
                }
              />
            </Col>
            <Col span={2}>
              <Meta
                title={<div className={styles.title}>Severity</div>}
                description={
                  <div className={styles.text}>
                    <Tag color={getColorBySeverity(riskLevel)}>
                      {riskLevel === 'N/a' ? 'N/A' : riskLevel}
                    </Tag>
                  </div>
                }
              />
            </Col>

            <Col span={4} offset={1}>
              <Meta
                title={<div className={styles.title}>Service</div>}
                description={
                  <Tooltip
                    title={AllServices.getFullName(service) ? AllServices.getFullName(service) : ''}
                  >
                    <div className={styles.text}>
                      <Tag color="orange">
                        {AllServices.getFullName(service).length > 20
                          ? AllServices.getFullName(service)
                              .substring(0, 20)
                              .concat('...')
                          : AllServices.getFullName(service)}
                      </Tag>
                    </div>
                  </Tooltip>
                }
              />
            </Col>

            <Col span={4}>
              <Meta
                title={<div className={styles.title}>Type</div>}
                description={
                  <div className={styles.text}>
                    <Tag color="blue">{renderCategory()}</Tag>
                  </div>
                }
              />
            </Col>

            <Col span={5} offset={1}>
              <Meta
                title={<div className={styles.title}>Cloud Accounts</div>}
                description={
                  <div className={styles.tags}>
                    <Popover
                      content={
                        cloudAccounts &&
                        cloudAccounts.map((v, i) => {
                          return (
                            <div key={i} className={styles.tags}>
                              <Tag style={{ marginBottom: 3 }}>
                                {v.accountName}
                                <img
                                  src={
                                    v.provider === 'AWS'
                                      ? '/awslogo.png'
                                      : v.provider === 'AZURE'
                                      ? '/azure@2x.png'
                                      : '/gcplogo.png'
                                  }
                                  alt={
                                    v.provider === 'AWS'
                                      ? '/aws'
                                      : v.provider === 'AZURE'
                                      ? '/azure'
                                      : '/gcp'
                                  }
                                  height="18px"
                                  style={{
                                    marginBottom: v.provider === 'GCP' ? '0px' : '5px',
                                    marginRight:
                                      v.provider === 'AWS'
                                        ? '-7px'
                                        : v.provider === 'GCP'
                                        ? '-10px'
                                        : '',
                                    marginLeft:
                                      v.provider === 'AZURE'
                                        ? '6px'
                                        : v.provider === 'GCP'
                                        ? '-4px'
                                        : '',
                                    height:
                                      v.provider === 'AZURE'
                                        ? '12px'
                                        : v.provider === 'GCP' && '20px',
                                  }}
                                />
                              </Tag>
                            </div>
                          );
                        })
                      }
                    >
                      {cloudAccounts &&
                        cloudAccounts.map((v, i) => {
                          if (i < 1) {
                            return (
                              <Tag key={i} style={{ marginBottom: 3 }}>
                                {truncateString(v.accountName, 20)}
                                <img
                                  src={
                                    v.provider === 'AWS'
                                      ? '/awslogo.png'
                                      : v.provider === 'AZURE'
                                      ? '/azure@2x.png'
                                      : '/gcplogo.png'
                                  }
                                  alt={
                                    v.provider === 'AWS'
                                      ? '/aws'
                                      : v.provider === 'AZURE'
                                      ? '/azure'
                                      : '/gcp'
                                  }
                                  height="18px"
                                  style={{
                                    marginBottom: v.provider === 'GCP' ? '0px' : '5px',
                                    marginRight:
                                      v.provider === 'AWS'
                                        ? '-7px'
                                        : v.provider === 'GCP'
                                        ? '-10px'
                                        : '',
                                    marginLeft:
                                      v.provider === 'AZURE'
                                        ? '6px'
                                        : v.provider === 'GCP'
                                        ? '-4px'
                                        : '',
                                    height:
                                      v.provider === 'AZURE'
                                        ? '12px'
                                        : v.provider === 'GCP' && '20px',
                                  }}
                                />{' '}
                                {cloudAccounts.length > 1 && `+ ${cloudAccounts.length - 1}`}
                              </Tag>
                            );
                          }
                        })}
                    </Popover>
                  </div>
                }
              />
            </Col>
          </Row>
        </div>
        {riskType == 'osVulnerability' && (
          <div
            className="sig-card"
            style={{ backgroundColor: '#FAFAFA', padding: 20, borderRadius: 6 }}
          >
            <Row type="flex" style={{ marginBottom: 12 }}>
              <Col span={4} style={{ fontSize: '14px', color: '#000000', fontWeight: 500 }}>
                Affected Packages
              </Col>
              <Col span={18} style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.5)' }}>
                {AffectedPackages?.map((item, index) => (
                  <span>{`${item.name}${index != AffectedPackages?.length - 1 ? ', ' : ' '}`}</span>
                ))}
              </Col>
            </Row>
            <Row type="flex" style={{ marginBottom: 12 }}>
              <Col span={4} style={{ fontSize: '14px', color: '#000000', fontWeight: 500 }}>
                CVSS Vector
              </Col>
              <Col span={18} style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.5)' }}>
                {cvssVector ? cvssVector : 'none'}
              </Col>
            </Row>
            <Row type="flex" style={{ marginBottom: 12 }}>
              <Col span={4} style={{ fontSize: '14px', color: '#000000', fontWeight: 500 }}>
                CVSS Score
              </Col>
              <Col span={18} style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.5)' }}>
                {cvssScore}
              </Col>
            </Row>
            <Row type="flex" style={{ marginBottom: 12 }}>
              <Col span={4} style={{ fontSize: '14px', color: '#000000', fontWeight: 500 }}>
                Know more
              </Col>
              <Col span={18} style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.5)' }}>
                <Row
                  align="middle"
                  style={{ color: '#1890FF', fontWeight: 500, cursor: 'pointer' }}
                >
                  <a
                    href={`https://nvd.nist.gov/vuln/detail/${_cveId}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <u>Go to NVD</u>

                    <svg
                      style={{ marginLeft: '5px' }}
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.7583 0.0507812H9.48709C9.30628 0.0507812 9.15984 0.197222 9.15984 0.378027C9.15984 0.558659 9.30628 0.705099 9.48709 0.705099H12.7583C12.9041 0.705617 13.0478 0.73912 13.1787 0.80319L6.63889 7.34341C6.57569 7.40437 6.53977 7.48813 6.53908 7.57603C6.53821 7.66375 6.57275 7.74802 6.63475 7.81002C6.69692 7.87219 6.78119 7.90673 6.86892 7.90587C6.95665 7.90518 7.0404 7.86908 7.10136 7.80605L13.642 1.26627C13.7059 1.39717 13.7396 1.54085 13.7401 1.6866V4.95786C13.7401 5.13849 13.8866 5.28493 14.0672 5.28493C14.2478 5.28493 14.3943 5.13849 14.3943 4.95786V1.6866C14.3937 1.25297 14.2214 0.837128 13.9147 0.53063C13.608 0.223933 13.1923 0.0514089 12.7587 0.0508784L12.7583 0.0507812Z"
                        fill="#1890FF"
                      />
                      <path
                        d="M14.0664 6.5931C13.8858 6.5931 13.7394 6.73954 13.7394 6.92017V12.8088C13.7394 13.069 13.6359 13.3187 13.4518 13.5026C13.2679 13.6867 13.0182 13.7901 12.758 13.7901H6.5427V9.5375C6.54218 9.10387 6.36966 8.68803 6.06295 8.38153C5.75642 8.07483 5.34058 7.90231 4.90698 7.90178H0.654332V1.68649C0.654332 1.42624 0.757772 1.17654 0.941688 0.992456C1.12578 0.80854 1.37549 0.7051 1.63572 0.7051H7.52431C7.70494 0.7051 7.85138 0.558659 7.85138 0.378027C7.85138 0.197222 7.70494 0.0507812 7.52431 0.0507812H1.63572C1.20209 0.0512993 0.786251 0.223818 0.479752 0.530534C0.173055 0.837058 0.000530504 1.2529 0 1.6865V12.809C0.000518081 13.2426 0.173037 13.6582 0.479752 13.9649C0.786277 14.2716 1.20212 14.444 1.63572 14.4445H12.7582C13.1918 14.444 13.6075 14.2716 13.9141 13.9649C14.2208 13.6582 14.3932 13.2425 14.3937 12.809V6.92036C14.3937 6.83367 14.3593 6.75043 14.298 6.68913C14.2366 6.62765 14.1535 6.59328 14.0666 6.59328L14.0664 6.5931ZM0.653992 12.8084V8.55574H4.90664C5.16688 8.55574 5.41659 8.65901 5.60067 8.8431C5.78459 9.02719 5.88803 9.27672 5.88803 9.53713V13.7898H1.63538C1.37514 13.7898 1.12543 13.6863 0.941348 13.5023C0.757431 13.3183 0.653992 13.0686 0.653992 12.8084V12.8084Z"
                        fill="#1890FF"
                      />
                    </svg>
                  </a>
                </Row>
              </Col>
            </Row>
            <Row type="flex" style={{ marginBottom: 12 }}>
              <Col span={4} style={{ fontSize: '14px', color: '#000000', fontWeight: 500 }}>
                Fix Available
              </Col>
              <Col span={18} style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.5)' }}>
                {renderFix()}
              </Col>
            </Row>
          </div>
        )}

        {riskType == 'malware' && (
          <div
            className="sig-card"
            style={{ backgroundColor: '#FAFAFA', padding: 20, borderRadius: 6 }}
          >
            {malwareHashes &&
              malwareHashes.map(item => (
                <>
                  <Row type="flex" style={{ marginBottom: 12 }}>
                    <Col span={4} style={{ fontSize: '14px', color: '#000000', fontWeight: 500 }}>
                      {item.type.toUpperCase()}
                    </Col>
                    <Col span={18} style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.5)' }}>
                      {item.value}
                    </Col>
                  </Row>
                </>
              ))}

            <Row type="flex" style={{ marginBottom: 12 }}>
              <Col span={4} style={{ fontSize: '14px', color: '#000000', fontWeight: 500 }}>
                Know more
              </Col>
              <Col span={18} style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.5)' }}>
                <Row
                  align="middle"
                  style={{ color: '#1890FF', fontWeight: 500, cursor: 'pointer' }}
                >
                  <a href={virusTotalLink} target="_blank">
                    <u>Show on Virus Total</u>
                    <svg
                      style={{ marginLeft: '5px' }}
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.7583 0.0507812H9.48709C9.30628 0.0507812 9.15984 0.197222 9.15984 0.378027C9.15984 0.558659 9.30628 0.705099 9.48709 0.705099H12.7583C12.9041 0.705617 13.0478 0.73912 13.1787 0.80319L6.63889 7.34341C6.57569 7.40437 6.53977 7.48813 6.53908 7.57603C6.53821 7.66375 6.57275 7.74802 6.63475 7.81002C6.69692 7.87219 6.78119 7.90673 6.86892 7.90587C6.95665 7.90518 7.0404 7.86908 7.10136 7.80605L13.642 1.26627C13.7059 1.39717 13.7396 1.54085 13.7401 1.6866V4.95786C13.7401 5.13849 13.8866 5.28493 14.0672 5.28493C14.2478 5.28493 14.3943 5.13849 14.3943 4.95786V1.6866C14.3937 1.25297 14.2214 0.837128 13.9147 0.53063C13.608 0.223933 13.1923 0.0514089 12.7587 0.0508784L12.7583 0.0507812Z"
                        fill="#1890FF"
                      />
                      <path
                        d="M14.0664 6.5931C13.8858 6.5931 13.7394 6.73954 13.7394 6.92017V12.8088C13.7394 13.069 13.6359 13.3187 13.4518 13.5026C13.2679 13.6867 13.0182 13.7901 12.758 13.7901H6.5427V9.5375C6.54218 9.10387 6.36966 8.68803 6.06295 8.38153C5.75642 8.07483 5.34058 7.90231 4.90698 7.90178H0.654332V1.68649C0.654332 1.42624 0.757772 1.17654 0.941688 0.992456C1.12578 0.80854 1.37549 0.7051 1.63572 0.7051H7.52431C7.70494 0.7051 7.85138 0.558659 7.85138 0.378027C7.85138 0.197222 7.70494 0.0507812 7.52431 0.0507812H1.63572C1.20209 0.0512993 0.786251 0.223818 0.479752 0.530534C0.173055 0.837058 0.000530504 1.2529 0 1.6865V12.809C0.000518081 13.2426 0.173037 13.6582 0.479752 13.9649C0.786277 14.2716 1.20212 14.444 1.63572 14.4445H12.7582C13.1918 14.444 13.6075 14.2716 13.9141 13.9649C14.2208 13.6582 14.3932 13.2425 14.3937 12.809V6.92036C14.3937 6.83367 14.3593 6.75043 14.298 6.68913C14.2366 6.62765 14.1535 6.59328 14.0666 6.59328L14.0664 6.5931ZM0.653992 12.8084V8.55574H4.90664C5.16688 8.55574 5.41659 8.65901 5.60067 8.8431C5.78459 9.02719 5.88803 9.27672 5.88803 9.53713V13.7898H1.63538C1.37514 13.7898 1.12543 13.6863 0.941348 13.5023C0.757431 13.3183 0.653992 13.0686 0.653992 12.8084V12.8084Z"
                        fill="#1890FF"
                      />
                    </svg>
                  </a>
                </Row>
              </Col>
            </Row>
          </div>
        )}
      </Card>
    </div>
  );
}

export default SingleSignatureDetail;
